
import _default from './default/theme.js';
import black from './black/theme.js';
import gray from './gray/theme.js';

const origin = {};

Object.assign(origin,_default,black,gray);

export default origin;